require([
      'app/modules/forms'
    ],
    function(Forms){
      $('.invite .invite-form').on('submit', function(e){
        e.preventDefault();
        Forms.submit($(this), 'invite_')
      });
    }
);
